import React from "react";
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
	pointer: { cursor: "pointer" },
	error: {
		height: 20,
		marginTop: 4,
	},
	root: {
		width: "100%",
		// height: 24,
	},
}));
/**
 * Define text input for general use
 *
 * @param {string} id - id of element to be more accessible for screen readers
 * @param {bool} error - if true, label will be displayed in error state
 * @param {node} label - label content
 * @param {function} onChange - callback function when value is changed
 * @param {string} placeholder - hint text when field is empty
 * @param {any} value - value of the text input
 * @param {string} className - override or extend styles of component
 * @param {bool} required - whether the input is required
 * @param {node} helperText - helper text content
 *
 * @return {TextField component}
 */
function TraxxInput({
	id,
	error,
	label,
	onChange,
	placeholder,
	value,
	type = "text",
	className,
	required,
	helperText,
	autoComplete = "tel-national username",
	...props
}) {
	const classes = useStyles();
	return (
		<div className={clsx(classes.root, className)}>
			<TextField
				id={id}
				fullWidth
				label={label}
				onChange={onChange}
				placeholder={placeholder}
				value={value}
				type={type}
				required={required}
				helperText={error}
				autoComplete={autoComplete}
				{...props}
			/>
		</div>
	);
}
export default TraxxInput;

TraxxInput.propTypes = {
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	id: PropTypes.string,
	label: PropTypes.string,
};

TraxxInput.defaultProps = {
	error: undefined,
	id: "",
	label: "",
};
